import { MutationTree } from "vuex";
import { Role } from "@/types";
import { IDataProvider } from "@/store";
import {
  ITransferAuthority,
  ITransferAuthorityState,
} from "@/store/modules/transferAuthority/state";

export enum TransferAuthorityMutations {
  SET_ONE = "SET_ONE_TRANSFER_AUTHORITY",
  SET_ALL = "SET_ALL_TRANSFER_AUTHORITY",
  SET_LAZY_DATA = "SET_LAZY_DATA_TRANSFER_AUTHORITY",
}

export const mutations: MutationTree<ITransferAuthorityState> = {
  [TransferAuthorityMutations.SET_ONE](state, payload: ITransferAuthority) {
    state.transferAuthority = payload;
  },
  [TransferAuthorityMutations.SET_ALL](state, payload: ITransferAuthority[]) {
    state.transferAuthorities = payload;
  },
  [TransferAuthorityMutations.SET_LAZY_DATA](
    state,
    payload: IDataProvider<ITransferAuthority>
  ) {
    state.dataProvider = payload;
  },
};
